import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: tv({
    base: 'relative flex drop-shadow-[0_2.87rem_3.82rem_rgba(242,103,89,0.2)]',
    variants: {
      status: {
        locked: 'drop-shadow-[0_2.8rem_4rem_rgba(108,174,199,0.2)]',
        cancelled: 'drop-shadow-[0px_24px_48px_rgba(221,224,227,0.5)]',
        expired: 'drop-shadow-[0px_24px_48px_rgba(221,224,227,0.5)]',
        inactive: '',
        active: '',
      },
    },
  }),
};
